import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/resources/fashionable-canes-shopify-seo-case-study")({
  beforeLoad: () => {
    throw redirect({ to: "/resources/fashionable-canes-seo-case-study", statusCode: 301 });
  },
});
